import React from 'react';
import { Card, Typography } from 'antd';
import { ClockCircleOutlined, StopOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';

const { Title, Text } = Typography;

const COPY = {
  pending: {
    icon: <ClockCircleOutlined style={{ fontSize: 48, color: 'var(--status-warning)' }} />,
    title: 'Waiting for approval',
    body: "Your account has been created and is waiting for a server admin to approve it. You'll get full access as soon as it's reviewed.",
  },
  rejected: {
    icon: <StopOutlined style={{ fontSize: 48, color: 'var(--status-error)' }} />,
    title: 'Access denied',
    body: 'A server admin has denied access to this account.',
  },
};

/**
 * Full-screen replacement for the app while a local registration is pending
 * or rejected (#35). Rendered by ProtectedRoute instead of `children`.
 */
function RegistrationStatusScreen({ status }) {
  const { logout } = useAuth();
  const { icon, title, body } = COPY[status] || COPY.pending;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'var(--bg-primary)',
    }}>
      <Card style={{ textAlign: 'center', maxWidth: 400 }}>
        <div style={{ marginBottom: 'var(--sp-4)' }}>{icon}</div>
        <Title level={3} style={{ marginTop: 0 }}>{title}</Title>
        <Text type="secondary">{body}</Text>
        <div style={{ marginTop: 'var(--sp-6)' }}>
          <a onClick={() => window.location.reload()} style={{ cursor: 'pointer', marginRight: 'var(--sp-4)' }}>Refresh</a>
          <a onClick={logout} style={{ cursor: 'pointer' }}>Log out</a>
        </div>
      </Card>
    </div>
  );
}

export default RegistrationStatusScreen;
